<template>
  <node-view-wrapper as="li" style="display:flex;align-items:flex-start;gap:8px;margin-bottom:14px;">
    <span class="icon-list-item-icon-wrapper" contenteditable="false">
      <button type="button" class="icon-list-item-icon" title="Cambiar icono" @click="togglePicker">
        <font-awesome-icon :icon="iconFaName" />
      </button>

      <div v-if="showPicker" class="icon-list-item-picker">
        <button
            v-for="key in iconKeys"
            :key="key"
            type="button"
            class="icon-list-item-picker-option"
            :class="{ 'icon-list-item-picker-option--active': key === node.attrs.icon }"
            :title="key"
            @click="selectIcon(key)"
        >
          <font-awesome-icon :icon="icons[key].faIcon" />
        </button>
      </div>
    </span>

    <div class="icon-list-item-text">
      <node-view-content as="span" />
    </div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-3'
import { ICON_LIST_ICONS } from './iconListIcons'

export default {
  name: 'IconListItemNodeView',

  components: {
    NodeViewWrapper,
    NodeViewContent,
  },

  props: nodeViewProps,

  data() {
    return {
      showPicker: false,
      icons: ICON_LIST_ICONS,
      iconKeys: Object.keys(ICON_LIST_ICONS),
    }
  },

  computed: {
    iconFaName() {
      const spec = ICON_LIST_ICONS[this.node.attrs.icon]
      return spec ? spec.faIcon : ICON_LIST_ICONS.info.faIcon
    },
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, true)
  },

  methods: {
    togglePicker() {
      this.showPicker = !this.showPicker
      if (this.showPicker) {
        this.$nextTick(() => document.addEventListener('click', this.handleOutsideClick, true))
      } else {
        document.removeEventListener('click', this.handleOutsideClick, true)
      }
    },
    handleOutsideClick(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.showPicker = false
        document.removeEventListener('click', this.handleOutsideClick, true)
      }
    },
    selectIcon(key) {
      this.updateAttributes({ icon: key })
      this.showPicker = false
      document.removeEventListener('click', this.handleOutsideClick, true)
    },
  },
}
</script>

<style scoped>
.icon-list-item-icon-wrapper {
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;
}

.icon-list-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
}

.icon-list-item-picker {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 20;
  display: flex;
  gap: 4px;
  margin-top: 4px;
  padding: 6px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.icon-list-item-picker-option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 0.25rem;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: #374151;
}

.icon-list-item-picker-option:hover {
  background-color: #f3f4f6;
}

.icon-list-item-picker-option--active {
  border-color: #045DB5;
  color: #045DB5;
}

.icon-list-item-text {
  flex: 1;
}
</style>
